
import { LeadingIndicator } from "../leadingIndicador.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";


export class LeadingIndicatorSerializer extends BaseSerializer {

    public deserialize( data: any ): any {
        const gp = new LeadingIndicator();
        this._copyAttributes(gp, data);
        return gp;

    }

}
